import { SECTION_CONFIGS } from '../../constants/sectionConfig.constants';
import type { Application } from '../../types/application.types';
import { CollapsibleSection } from '../shared/CollapsibleSection';
import { FormattedField } from '../shared/FormattedField';

interface BookingDetailsStepProps {
  application: Application;
}

export function BookingDetailsStep({ application }: BookingDetailsStepProps) {
  const config = SECTION_CONFIGS.reservation;

  // Format choisi : combiner spaceType.name + roomName si disponible
  // Ex: "Bureau" + "VIP" = "Bureau VIP"
  const spaceTypeName = application.spaceType?.name || application.specificDetails?.spaceType?.name;
  const roomNameOnly = application.roomName || application.specificDetails?.roomName;

  // Construire le nom complet : "Bureau VIP" ou juste "Bureau" si pas de roomName
  let displayRoomName: string | null = null;
  if (spaceTypeName && roomNameOnly) {
    displayRoomName = `${spaceTypeName} ${roomNameOnly}`;
  } else if (roomNameOnly) {
    displayRoomName = roomNameOnly;
  } else if (spaceTypeName) {
    displayRoomName = spaceTypeName;
  }

  // Dates
  const startDate = application.startDate || application.specificDetails?.startDate;
  const endDate = application.endDate || application.specificDetails?.endDate;
  const createdAt = application.createdAt;

  // Raison de la réservation
  const bookingReason = application.bookingReason || application.specificDetails?.bookingReason;

  return (
    <CollapsibleSection title={config.title} color={config.color} icon={config.icon} defaultOpen={config.defaultOpen}>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-4">
        {/* Format choisi */}
        {displayRoomName && <FormattedField fieldKey="roomName" value={displayRoomName} />}

        {/* Date de la réservation (création) */}
        {createdAt && <FormattedField fieldKey="createdAt" value={createdAt} />}

        {/* Date de début */}
        {startDate && <FormattedField fieldKey="startDate" value={startDate} />}

        {/* Date de fin */}
        {endDate && <FormattedField fieldKey="endDate" value={endDate} />}

        {/* Raison de la réservation */}
        {bookingReason && (
          <div className="col-span-full">
            <FormattedField fieldKey="bookingReason" value={bookingReason} />
          </div>
        )}
      </div>
    </CollapsibleSection>
  );
}
